"use client"

import React from "react"

export default function RoleDropBanner({ className }) {
  return (
    <>
      <div className={`fixed top-0 left-0 right-0 w-full bg-gradient-to-r from-[#02B491] to-[#018f73] z-[100] shadow-md banner-container ${className || ''}`}>
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-center min-h-[2.75rem] py-2 sm:py-0 sm:h-11 text-white">
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 justify-center w-full">
              <p className="font-medium text-sm sm:text-base text-center px-2">
                Let candidates know you're hiring - open a role to receive top 1% applicants!
              </p>
              <button
                onClick={() => (window.location.href = "/roles")}
                className="inline-flex items-center justify-center text-xs sm:text-sm font-semibold text-[#02B491] bg-white px-3 py-1 sm:py-1.5 rounded-full hover:bg-opacity-90 transition-colors duration-200 ease-in-out whitespace-nowrap my-1 sm:my-0"
              >
                Post a role
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3 sm:h-4 sm:w-4 ml-1 sm:ml-1.5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Add CSS to hide banner on mobile */}
      <style jsx global>{`
        @media (max-width: 767px) {
          .banner-container {
            display: none !important;
          }
        }
        body.modal-open .banner-container {
          filter: blur(4px) brightness(0.8);
          pointer-events: none;
          transition: filter 0.2s;
        }
      `}</style>
    </>
  )
}
